<template>
  <div>
    <b-form-select
      :options="optionsState"
      v-model="compValue"
      :disabled="readonly"
    >
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: "StateDropdown",
  props: {
    stateId: Number,
    readonly: {
      type: Boolean,
      default: false
    },
    states: Array,
  },
  data() {
    return {
      optionsState: [{ value: null, text: "Carregando estados" }],
    };
  },
  created() {
    if (this.states && this.states != null) {
      this.optionsState = this.states;
    } else {
      this.loadStates();
    }
  },
  computed: {
    compValue: {
      get: function () {
        return this.stateId;
      },
      set: function (newValue) {
        let selectedState = null;
        let selectedStateId = parseInt(newValue);
        for (let state of this.optionsState) {
          if (parseInt(state.value) == selectedStateId) {
            selectedState = state;
            break;
          }
        }
        this.$emit("update:changeId", selectedStateId);
        if (selectedState) {
          this.$emit("update:changeAbrev", selectedState.abrev);
          this.$emit("update:changeName", selectedState.text);
        } else {
          this.$emit("update:changeAbrev", "");
          this.$emit("update:changeName", "");
        }
      },
    },
  },
  methods: {
    loadStates() {
      this.$api
        .get("/state/getDropdownOptions")
        .then((response) => {
          this.optionsState = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
